/* eslint-disable no-duplicate-case */
import React, { useEffect, useState, useRef } from "react";
import { Layout, Card, Badge, Button, Banner, Link } from "@shopify/polaris";
import { Link as RoterLink } from "react-router-dom";

import config from "../../config/config";
import { useDispatch, useSelector } from "react-redux";

import PlanTable from "./PlanTable";
import Chart from "./Chart";
import { Row, Col } from "reactstrap";
import man from "../../assets/man.jpg";
import ring from "../../assets/ring.gif";
import Pollly from "./Pollly";
import { actFecthPlanTable } from "../../actions";
import Feedback from "./Feedback";
import callApi from "../../utils/apiCaller";
import DisputeTemplate from "./DisputeTemplate";
import YearlyPlanDashboard from "../feature/yearly/YearlyPlanDashboard";

const Credentials = (props) => {
	const resultsRef = useRef();
	const { listPayPalAccounts, showPlanDasboard } = useSelector(
		(state) => state
	);
	const dataSettings = useSelector((state) => state.dataSettings);
	const dispatch = useDispatch();

	const [planName, setPlanName] = useState("Free");
	const [submitFeedback, setsubmitFeedback] = useState(false);
	const [showPlan, setShowPlan] = useState(false);
	const [limitOrder, setLimitOrder] = useState(100);

	const openAllPlan = () => {
		// setShowPlan(true);
		dispatch(actFecthPlanTable(true));
		window.scrollTo({
			behavior: "smooth",
			top: resultsRef.current.offsetTop,
		});
	};

	const getAccountStatus = (confirm_status) => {
		if (confirm_status === "1") {
			return (
				<Badge status="success" progress="complete">
					Confirmed
				</Badge>
			);
		} else if (confirm_status === "-1") {
			return (
				<Badge status="warning" progress="complete">
					Invalid Paypal Account
				</Badge>
			);
		}
	};

	const openTechSupport = (content) => {
		if (typeof window.$crisp != undefined && window.$crisp != undefined) {
			window.$crisp.push(["do", "message:send", ["text", content]]);
			window.$crisp.push([
				"set",
				"session:event",
				["synctrack-tech-support"],
			]);
		}
	};

	useEffect(() => {
		switch (dataSettings.plan) {
			case "free":
				setPlanName("Free");
				break;
			case "basic":
				setPlanName("Basic");
				break;
			case "pro":
				setPlanName("Pro");
				break;
			case "pro_plus":
				setPlanName("Pro Plus");
				break;
			case "unlimited":
				setPlanName("Unlimited");
				break;
			default:
				setPlanName("Free");
		}
	}, [dataSettings]);
	useEffect(() => {
		if (showPlanDasboard.scrollPlanTable === true) {
			window.scrollTo({
				behavior: "smooth",
				top: resultsRef.current.offsetTop,
			});
		}
	}, [showPlanDasboard.count]);

	useEffect(() => {
		checkSubmitFeedback();
	}, []);

	const checkSubmitFeedback = () => {
		callApi("get", {
			action: "checkSubmitFeedback",
		}).then(async (res) => {
			if (res.data.state === 1) {
				setsubmitFeedback(true);
			}
		});
	};

	return (
		<div className="mt-4 app-credentials">
			<Row className="d-flex">
				<Col className="d-flex chart" xs="12" sm="12" md="12" lg="12">
					<Card
						title={
							window.innerWidth < 800
								? "Last 7 days"
								: "Last 14 days"
						}
						sectioned
					>
						<Chart storeSelected={props.storeSelected} />
					</Card>
				</Col>
			</Row>
			{/* {dataSettings.plan != "pro_plus" &&
      dataSettings.plan != "unlimited" &&
      config.platform != "WOO_COMMERCE" ? (
        <Row>
          <Col>
            <YearlyPlanDashboard />
          </Col>
        </Row>
      ) : null} */}
			{config.wooType !== "extension" ? (
				<Row className="mt-4 d-flex">
					<Col
						className="d-flex"
						xs="12"
						sm="12"
						md="12"
						lg="12"
						xl="6"
					>
						<DisputeTemplate />
					</Col>
					<Col
						className="d-flex chart"
						xs="12"
						sm="12"
						md="12"
						lg="12"
						xl="6"
					>
						<Card title="Account Status" sectioned>
							<div className="mt-4">
								<table className="w-100 app_instructions_page_add_user_table app_status_table m-auto">
									<tbody>
										<tr>
											<td>Your plan:</td>
											<td className="right">
												<strong>{planName}</strong>
												<br />
												{dataSettings.plan_extend !==
													"" &&
												dataSettings.shop !==
													dataSettings.shop_parent
													? " (Inherited from store: " +
													  dataSettings.plan_extend +
													  ")"
													: ""}
											</td>
										</tr>
										<tr>
											<td>Payment subscription:</td>
											<td className="right">
												<strong
													style={{
														textTransform:
															"capitalize",
													}}
												>
													{dataSettings.subscription}
												</strong>
											</td>
										</tr>
										<tr>
											<td>Paypal Integration:</td>
											<td className="right account-integrated">
												<Badge
													status={
														listPayPalAccounts.length ===
														0
															? "critical"
															: "success"
													}
													progress="complete"
												>
													{listPayPalAccounts.length}
													{listPayPalAccounts.length >
													1
														? " Accounts"
														: " Account"}{" "}
													Integrated
												</Badge>
											</td>
										</tr>
										{dataSettings.sync_stripe == "1" ? (
											<tr>
												<td>Stripe Integration:</td>
												<td className="right account-integrated">
													<Badge
														status={
															dataSettings.stripe_token
																? "success"
																: "critical"
														}
														progress="complete"
													>
														{dataSettings.stripe_token
															? dataSettings.stripe_token +
															  " Token Connected"
															: "Token Not added Yet"}
													</Badge>
												</td>
											</tr>
										) : null}
										<tr>
											<td>
												The number of orders synced:
											</td>
											<td className="right">
												<strong>
													{dataSettings.quota} orders{" "}
												</strong>
												per/month
											</td>
										</tr>
										<tr>
											<td>Used this month: </td>
											<td className="right">
												<strong>
													{dataSettings.usage}/
													{dataSettings.quota} orders{" "}
												</strong>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
							<br />
							<div style={{ marginBottom: "2rem" }}>
								<Button primary onClick={openAllPlan}>
									View all plans
								</Button>
							</div>
						</Card>
					</Col>
				</Row>
			) : null}
			<div ref={resultsRef}>
				{showPlanDasboard.scrollPlanTable === true ? (
					<PlanTable />
				) : null}
			</div>
		</div>
	);
};

export default Credentials;
